import React from 'react';
import ReactDOM from 'react-dom';
import Styled from './styles';

const renderChildren = (children, props) => (
  <Styled.InlineFeedbackMessageOverlay {...props}>{children}</Styled.InlineFeedbackMessageOverlay>
);

export interface InlineFeedbackOverlayProps {
  /** Specifying the target will allow the overlay to fill that target container. */
  target?: any,
  children: React.ReactNode,
  /** @ignore, used internally. */
  theme?: any
}

/** Renders an overlay behind InlineFeedbackMessagesContainer  */
const InlineFeedbackOverlay = (props: InlineFeedbackOverlayProps) => {
  const {
    target,
    children,
    ...otherProps
  } = props;
  const [node, setNode] = React.useState(undefined);
  React.useEffect(() => {
    const container = document.querySelector(target);
    setNode(container);
  }, [target]);
  if (node) {
    return ReactDOM.createPortal(renderChildren(children, otherProps), node);
  }
  return renderChildren(children, otherProps);
};
InlineFeedbackOverlay.defaultProps = {
  target: undefined,
  theme: {}
};
InlineFeedbackOverlay.displayName = 'InlineFeedbackMessageOverlay';
export default InlineFeedbackOverlay;
